import { render, staticRenderFns } from "./AlertExpired.vue?vue&type=template&id=24f6db2c&scoped=true"
import script from "./AlertExpired.vue?vue&type=script&lang=js"
export * from "./AlertExpired.vue?vue&type=script&lang=js"
import style0 from "./AlertExpired.vue?vue&type=style&index=0&id=24f6db2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6db2c",
  null
  
)

export default component.exports